var checkInputEmpty = function (form) {
    var inputsAndSelects = Array.from(form.querySelectorAll('input, select'));
    var emptyElements = inputsAndSelects.filter(function (element) {
        return element.tagName === 'SELECT'
            ? !element.options[element.selectedIndex].value
            : !element.value;
    });
    emptyElements.forEach(function (inputsAndSelects) {
        var _a;
        var label = (_a = inputsAndSelects.closest('.input-group')) === null || _a === void 0 ? void 0 : _a.querySelector('label');
        label.classList.add('text-danger');
    });
    return emptyElements.length > 0;
};
var sendForm = function (form, button, path, body) {
    var flashBlock = document.querySelector('#contactFormFlash');
    var successFlash = flashBlock.querySelector('.alert-success-global');
    var errorGlobalFlash = flashBlock.querySelector('.danger-global');
    var errorMissingValueFlash = flashBlock.querySelector('.danger-missing-value');
    var isEmpty = checkInputEmpty(form);
    if (isEmpty) {
        errorMissingValueFlash.classList.remove('d-none');
        return;
    }
    fetch(path, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function (res) {
        if (res.ok) {
            form.classList.add('d-none');
            errorGlobalFlash.classList.add('d-none');
            errorMissingValueFlash.classList.add('d-none');
            successFlash.classList.remove('d-none');
        }
        else {
            successFlash.classList.add('d-none');
            errorMissingValueFlash.classList.add('d-none');
            errorGlobalFlash.classList.remove('d-none');
        }
    });
};
export { sendForm };
